import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";
import GenderTable from "../../DataTables/MasterData/Gender/GenderTable";

//MODALS
import CreateGenderModal from "../../UiKits/Modal/MasterData/Gender/CreateGender";

const GenderContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Gender"
        parent="Master Data / Personal Information"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Gender Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage gender options used throughout the HRIS for employee
                  and applicant personal information.
                </P>
                <CreateGenderModal />
                <GenderTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GenderContainer;
